export enum QuestionDirectionIndex {
  previous = -1,
  next = 1,
}
